export class Estados{
    public id_estado_pk:Number;
    public nombre:String;
    
}